// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CompanyDetailsPage-module__tableHeader__-oNa1{font-weight:bold}\n", ""]);
// Exports
exports.locals = {
	"tableHeader": "CompanyDetailsPage-module__tableHeader__-oNa1"
};
module.exports = exports;
